"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _AccordionContext = _interopRequireDefault(require("./AccordionContext"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Accordion/AccordionProvider.js";
function AccordionProvider(_ref) {
  var children = _ref.children;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);
  };
  return /*#__PURE__*/_react["default"].createElement(_AccordionContext["default"].Provider, {
    value: {
      isOpen: isOpen,
      handleToggle: handleToggle
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 12
    }
  }, children);
}
var _default = exports["default"] = AccordionProvider;